import { render, staticRenderFns } from "./TopRegions.vue?vue&type=template&id=190fec14&scoped=true&"
import script from "./TopRegions.vue?vue&type=script&lang=js&"
export * from "./TopRegions.vue?vue&type=script&lang=js&"
import style0 from "./TopRegions.vue?vue&type=style&index=0&id=190fec14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190fec14",
  null
  
)

export default component.exports